import React from "react";
import { motion } from "framer-motion";
import { SERVICE_GROUPS } from "./psoData";
import PsoLayout, { NAVY, EMERALD, CREAM, SLATE } from "./PsoLayout";

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.5, ease: "easeOut" } };

export default function PsoServices() {
  return (
    <PsoLayout active="services">
      <section className="py-16 sm:py-20" style={{ background: NAVY }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <motion.span {...fadeUp} className="text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: "#6EE7B7" }}>Services</motion.span>
          <motion.h1 {...fadeUp} className="mt-4 text-3xl sm:text-5xl font-extrabold text-white">Accounting, Tax & Compliance</motion.h1>
        </div>
      </section>

      <section className="py-16" style={{ background: CREAM }}>
        <div className="max-w-5xl mx-auto px-5 sm:px-8 space-y-6">
          {SERVICE_GROUPS.map((g, i) => (
            <motion.div key={g.title} {...fadeUp} transition={{ ...fadeUp.transition, delay: i * 0.05 }} className="bg-white rounded-lg p-6 shadow-sm">
              <h3 className="font-bold text-lg mb-3" style={{ color: EMERALD }}>{g.title}</h3>
              <div className="flex flex-wrap gap-2">
                {g.areas.map((a) => <span key={a} className="text-xs font-medium rounded-full px-3.5 py-1.5" style={{ background: CREAM, color: NAVY }}>{a}</span>)}
              </div>
            </motion.div>
          ))}
        </div>
        <motion.p {...fadeUp} className="max-w-5xl mx-auto px-5 sm:px-8 mt-6 text-xs" style={{ color: SLATE }}>Reach out to discuss whether your specific need is a fit — not every service applies to every client type.</motion.p>
      </section>
    </PsoLayout>
  );
}
